"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const numeral_1 = __importDefault(require("numeral"));
const classnames_1 = __importDefault(require("classnames"));
const currency_symbol_map_1 = __importDefault(require("currency-symbol-map"));
const mui_1 = require("tss-react/mui");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const utils_1 = require("utils/utils");
const utils_2 = require("data/transactions/utils");
const utils_3 = require("./utils");
const styles_1 = require("./styles");
const AmountField = (_a) => {
    var { editable, className, style, InputProps, onKeyDown, zeroIsBlank, onChange, amountType = 'amount', value, updateValue, useAbsoluteValue, onBlur, onFocus, autoFocus, inputRef, currencySymbol = 'USD', currencyGap, omitCents, proposedSign, lockInitialProposedSign, showSign, showColor = utils_3.ShowColorEnum.MANUAL, color, disableUnderline, submitOnBlur, onSubmit, showAmountAdornment, compact, hideCurrencyString, variant, textFieldVariant = 'standard', marginProp, label, maxChars, classes } = _a, others = __rest(_a, ["editable", "className", "style", "InputProps", "onKeyDown", "zeroIsBlank", "onChange", "amountType", "value", "updateValue", "useAbsoluteValue", "onBlur", "onFocus", "autoFocus", "inputRef", "currencySymbol", "currencyGap", "omitCents", "proposedSign", "lockInitialProposedSign", "showSign", "showColor", "color", "disableUnderline", "submitOnBlur", "onSubmit", "showAmountAdornment", "compact", "hideCurrencyString", "variant", "textFieldVariant", "marginProp", "label", "maxChars", "classes"]);
    const textInput = (0, react_1.useRef)(null);
    const initialValueRef = (0, react_1.useRef)(value);
    const proposedSignRef = (0, react_1.useRef)(proposedSign);
    const selection = (0, react_1.useRef)({ start: false, end: false });
    const previousEditable = (0, react_1.useRef)(editable);
    const validateField = (0, react_1.useCallback)((valuePassed, noStrip = false) => {
        // only allow 2 decimals in amount field, and only 1 decimal point
        // need to give each field their own handler, and then have a default handler
        let str = '';
        let newVal = noStrip ? valuePassed : valuePassed.replace('$', '').trim();
        const legalChars = amountType === 'amount' || amountType === 'balance' ? '0123456789.-+' : '0123456789.';
        // strip out illegal characters (only numbers and decimals)
        for (let i = 0; i < newVal.length; i += 1) {
            str += legalChars.indexOf(newVal[i]) < 0 ? '' : newVal[i];
        }
        newVal = str;
        // This code will ensure there are only 2 digits to the right of the decimal
        if (str) {
            if (str.indexOf('.') >= 0 && str.length > 1) {
                if (str.length - str.indexOf('.') > 3 || valuePassed.indexOf('.') !== valuePassed.lastIndexOf('.')) {
                    newVal = parseFloat(Number(str).toFixed(2)).toString();
                }
            }
        }
        return newVal;
    }, [amountType]);
    const valueFromProps = (0, react_1.useCallback)(() => {
        let val = (0, numeral_1.default)(value || updateValue || '');
        if (editable && val === 0) {
            val = '';
        }
        else {
            val = val.format(`${showSign === utils_3.ShowSignEnum.ALWAYS ? '+-' : ''}0,00.00`);
            val = validateField(val, true);
        }
        return val;
    }, [value, updateValue, editable, showSign, validateField]);
    const [valueState, setValueState] = (0, react_1.useState)(() => valueFromProps());
    const [currencyString, setCurrencyString] = (0, react_1.useState)(() => !hideCurrencyString ? ((0, currency_symbol_map_1.default)(currencySymbol) || '').trim() : '');
    (0, react_1.useEffect)(() => {
        // Handle value updates
        if (!Number.isNaN(Number(value)) || !Number.isNaN(Number(updateValue))) {
            let newVal = value || updateValue || '';
            newVal = validateField(String(newVal), true);
            if (Number(newVal) !== Number(valueState)) {
                setValueState(newVal);
            }
        }
        // Handle proposedSign updates with lockInitialProposedSign logic
        if (proposedSign !== proposedSignRef.current &&
            (!lockInitialProposedSign || typeof proposedSignRef.current === 'undefined')) {
            proposedSignRef.current = proposedSign;
        }
        // Handle currency symbol updates
        if (currencySymbol !== currencyString) {
            setCurrencyString(((0, currency_symbol_map_1.default)(currencySymbol) || '').trim());
        }
        // Handle editable updates
        // This ensures that when the field becomes editable, it starts with the correct value
        if (editable && editable !== previousEditable.current) {
            setValueState(valueFromProps());
            previousEditable.current = editable;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, updateValue, currencySymbol, editable, proposedSign, lockInitialProposedSign, currencyString, validateField, valueFromProps]);
    (0, react_1.useEffect)(() => {
        if (textInput.current) {
            const { selectionStart, selectionEnd } = textInput.current;
            const update = (selection.current.start !== false && selection.current.start !== selectionStart) ||
                (selection.current.end !== false && selection.current.end !== selectionEnd);
            if (update && !(0, utils_1.isBrowser)('safari')) {
                textInput.current.setSelectionRange(selection.current.start, selection.current.end);
            }
        }
    });
    const tooltip = () => {
        if (compact) {
            return (0, utils_3.internalFormatNumber)(value, currencyString, '0,0.00', showSign);
        }
        return '';
    };
    const Wrap = compact ? QTip_1.default : react_1.default.Fragment;
    const wrapProps = compact ? { title: tooltip() } : {};
    let colorClass;
    switch (showColor) {
        case utils_3.ShowColorEnum.POSITIVE_ONLY:
            colorClass = value > 0 ? classes.green : undefined;
            break;
        case utils_3.ShowColorEnum.NEGATIVE_ONLY:
            colorClass = value < 0 ? classes.red : undefined;
            break;
        case utils_3.ShowColorEnum.ALWAYS:
            if (value < 0) {
                colorClass = classes.red;
            }
            else if (value > 0) {
                colorClass = classes.green;
            }
            break;
        case utils_3.ShowColorEnum.MANUAL:
            colorClass = classes[color];
            break;
        default:
            assert(false, `unknown color mode '${showColor}'`);
    }
    const otherProps = Object.assign({ style,
        InputProps,
        onChange,
        onBlur }, others);
    const renderStaticValue = () => {
        if (!(0, utils_1.exists)(value) || (zeroIsBlank && (0, utils_1.noNaN)(value) === 0)) {
            return <span>{'\u00A0'}</span>; // Danger, u00A0 may be removed from browser support.
        }
        return (0, utils_3.internalFormatNumber)(value, `${currencyString}${(currencyString && currencyGap) ? ' ' : ''}`, `0,0${omitCents ? '' : '.00'}${compact ? 'a' : ''}`, showSign);
    };
    const handleChange = (e) => {
        if (textInput.current) {
            selection.current = {
                start: textInput.current.selectionStart,
                end: textInput.current.selectionEnd,
            };
        }
        let newVal = validateField(e.target.value);
        setValueState(newVal);
        if (useAbsoluteValue) {
            // make negative
            newVal = `-${newVal}`;
        }
        e.target.value = newVal;
        if (onChange) {
            onChange(e, amountType);
        }
    };
    const handleFocus = (e) => {
        const numCharsToStrip = (currencyString ? currencyString.length + 1 : 0);
        const { target } = e;
        setTimeout(() => {
            if (showAmountAdornment) {
                target.select();
            }
            else {
                target.setSelectionRange(numCharsToStrip, 99);
            }
        }, 0);
        if (onFocus) {
            onFocus(e);
        }
        initialValueRef.current = valueState;
    };
    const handleOnBlur = (e, wasEnter = false) => {
        if (validateField(e.target.value).trim().length > 0) {
            let newVal = validateField(e.target.value);
            const valChanged = Number(newVal) !== Number(initialValueRef.current);
            const absValChanged = Math.abs(Number(newVal)) !== Math.abs(Number(initialValueRef.current));
            if (onBlur) {
                if (valChanged) {
                    newVal = (0, utils_2.quickenAmountToString)(newVal, absValChanged && (proposedSignRef.current || Math.sign(initialValueRef.current)));
                }
                e.target.value = newVal;
                onBlur(e, amountType, wasEnter);
            }
            setValueState(newVal);
        }
        else if (e.target.value === '' && onBlur) {
            onBlur(e, amountType, wasEnter);
        }
        if (submitOnBlur && onSubmit) {
            onSubmit();
        }
    };
    const setInputRef = (el) => {
        textInput.current = el;
        if (inputRef) {
            inputRef(el);
        }
    };
    const handleKeyPress = (event) => {
        var _a, _b;
        if (event.key === '.' && valueState.indexOf('.') >= 0) {
            // this is so that you can reset a selection with a period if a period is already selected
            const subStr = valueState.substring((_a = textInput.current) === null || _a === void 0 ? void 0 : _a.selectionStart, (_b = textInput.current) === null || _b === void 0 ? void 0 : _b.selectionEnd);
            const hasPeriod = subStr.indexOf('.') >= 0;
            if (!hasPeriod) {
                event.stopPropagation();
                event.preventDefault();
            }
        }
        if (event.key === 'Enter') {
            // if user hits Enter, treat like TAB and treat as a blur to capture the value
            const e = { target: { value: `${currencyString} ${valueState}` } };
            handleOnBlur(e, true);
            if (onSubmit) {
                onSubmit();
            }
        }
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    if (editable) {
        return (<TextField_1.default {...otherProps} className={(0, classnames_1.default)(classes.inputField, className)} sharedcomponentid="AMOUNT_FIELD" value={`${showAmountAdornment ? '' : `${currencyString}${currencyString ? ' ' : ''}`}${valueState}`} onChange={handleChange} autoFocus={autoFocus} label={label} margin={marginProp} onFocus={handleFocus} onBlur={handleOnBlur} inputRef={setInputRef} onKeyDown={handleKeyPress} variant={textFieldVariant} InputProps={Object.assign(Object.assign(Object.assign({}, InputProps), (disableUnderline && { disableUnderline: true })), { inputProps: {
                    className: classes.inputField,
                    maxLength: maxChars || (13 + (currencyString ? currencyString.length : 0) + (showSign === utils_3.ShowSignEnum.NEVER ? 0 : 1)),
                }, startAdornment: showAmountAdornment ? (<InputAdornment_1.default classes={{ root: classes.amountadornment }} disableTypography position="end">
              {currencyString}
            </InputAdornment_1.default>) : ('') })}/>);
    }
    return (<Wrap {...wrapProps}>
      <QTypography_1.default {...otherProps} variant={variant || 'inherit'} component="span" sharedcomponentid="AMOUNT_FIELD" className={(0, classnames_1.default)(...[classes.inputField, className, ...(colorClass ? [colorClass] : [])])}>
        {renderStaticValue()}
      </QTypography_1.default>
    </Wrap>);
};
exports.default = (0, mui_1.withStyles)(AmountField, styles_1.amountFieldStyles);
